<template>
  <div>
    <multiselect
      class="selectExample"
      v-model="selected"
      :options="options"
      multiple
      :filterable="true"
      :allow-empty="allowEmpty"
      :group-select="true"
      :max-height="100"
      :limit="3"
      placeholder="Type to search"
      :searchable="true"
      :select-label="''"
      deselect-label=""
      track-by="ID"
      @search-change="handleSearch"
      :custom-label="customLabel"
      name="Customer"
      :disabled="isDisable"
      :loading="isLoading"
    />
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/repositoryFactory";
import _ from "lodash";

const MasterRepository = RepositoryFactory.get("master");

export default {
  props: {
    isDisable: {
      type: Boolean,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    showAllLabel: {
      type: Boolean,
      default: false,
    },
    disabledSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      selected: [],
      filter: {
        search: "",
        length: 10,
        page: 1,
      },
      isLoading: false,
    };
  },
  methods: {
    customLabel(option) {
      return `${option.code} - ${option.name}`;
    },
    handleSearch: _.debounce(function (val) {
      if (this.disabledSearch) return;
      this.filter.search = val;
      this.getData();
    }, 1000),
    setAllSelected() {
      this.selected = {
        id: 0,
        code: "All",
        name: "Customer",
      };
    },
    getData(customParams) {
      this.isLoading = true;
      const params = {
        ...this.filter,
        ...customParams,
      };

      MasterRepository.getCustomersV2({
        params: params,
      })
        .then((resp) => {
          this.isLoading = false;
          if (resp.code == 200) {
            var options = [];
            if (this.showAllLabel && this.selected == null) {
              options.push({
                id: 0,
                code: "",
                name: "All",
              });
              this.selected = [];
              this.selected.push(options[0]);
            }
            resp.data.records.forEach(function (item) {
              options.push(item);
            }, options);
            this.options = options;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$vs.notify({
            title: "Error",
            text: "Error while fetching data",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        });
    },
    async setTerritoryID(id) {
      this.filter.territory_id = id;
      await this.getData();
    },
    async setTerritoryIDs(ids) {
      this.filter.territory_id = ids;
      await this.getData();
    },
    async setSelectedData(data) {
      this.selected = [];
      if (Array.isArray(data)) {
        this.selected = data;
      }else{
        this.selected.push(data);
      }
    },
    async setFilter(filter) {
      this.filter = filter;
      await this.getData();
    },
  },
  watch: {
    selected(v) {
      // check v is array or not
      if (Array.isArray(v)) {
        if (v.length > 1) {
          // remove ID = 0 from selected
          for (var i = 0; i < v.length; i++) {
            if (v[i].id == 0) {
              v.splice(i, 1);
            }
          }
        }
      }
      this.selected = v;
      console.log("selected customer", this.selected);
      this.$emit("data", v);
    },
  },
  mounted() {},
};
</script>
